// Optional email on the profile. Most accounts were made by quick save with a
// password the player never saw, so an email is the one sure way to prove the
// account is theirs if they ever lose it.
import React, { useEffect, useState } from 'react';
import { getMyEmail, setMyEmail } from '../../services/authService';
import { trackEvent } from '../../services/analyticsService';
import './EmailSetting.css';

export default function EmailSetting() {
  const [saved, setSaved] = useState(null); // null while loading
  const [value, setValue] = useState('');
  const [state, setState] = useState('idle'); // idle | saving | done | error
  const [error, setError] = useState('');

  useEffect(() => {
    let alive = true;
    getMyEmail().then((r) => {
      if (!alive) return;
      const email = (r && r.success && r.email) || '';
      setSaved(email);
      setValue(email);
    });
    return () => { alive = false; };
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setState('saving');
    const r = await setMyEmail(value.trim());
    if (r && r.success) {
      setSaved(r.email);
      setState('done');
      trackEvent('email_saved', { removed: !r.email });
    } else {
      setError((r && r.error) || 'Could not save');
      setState('error');
    }
  };

  return (
    <form className="email-setting" onSubmit={save}>
      <label className="email-setting-label" htmlFor="profile-email">
        Email <span className="email-setting-opt">(optional)</span>
      </label>
      <p className="email-setting-why">If you ever lose your password, this is how we know the account is yours. We never show it to anyone.</p>
      <div className="email-setting-row">
        <input id="profile-email" type="email" value={value} placeholder="you@example.com" autoComplete="email"
          onChange={(e) => { setValue(e.target.value); setState('idle'); }} disabled={saved === null || state === 'saving'} />
        <button type="submit" disabled={saved === null || state === 'saving' || value.trim() === (saved || '')}>
          {state === 'saving' ? 'Saving...' : 'Save'}
        </button>
      </div>
      {state === 'done' && <p className="email-setting-ok">{saved ? 'Saved ✓' : 'Removed ✓'}</p>}
      {state === 'error' && <p className="email-setting-err">⚠️ {error}</p>}
    </form>
  );
}
